import { useState } from "react";
import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
export const MPRToolConfig = (onMPRViewChange, setActiveTool) => ({
  name: "MPR",
  tool: "MPRTool",
  icon: <ViewInArIcon />,

  // Parent icon click
  customAction: () => {
    console.log("MPR Parent Clicked");
    setActiveTool?.("MPR_THREE_VIEW");
    onMPRViewChange?.("THREE_VIEW");
  },

  children: [
    {
      name: "Axial",
      tool: "MPR_AXIAL",
      customAction: () => {
        console.log("Axial");
        setActiveTool?.("MPR_AXIAL");
        onMPRViewChange?.("AXIAL");
      },
    },
    {
      name: "Sagittal",
      tool: "MPR_SAGITTAL",
      customAction: () => {
        console.log("Sagittal");
        setActiveTool?.("MPR_SAGITTAL");
        onMPRViewChange?.("SAGITTAL");
      },
    },
    {
      name: "Coronal",
      tool: "MPR_CORONAL",
      customAction: () => {
        console.log("Coronal");
        setActiveTool?.("MPR_CORONAL");
        onMPRViewChange?.("CORONAL");
      },
    },
    {
      name: "3 View",
      tool: "MPR_THREE_VIEW",
      customAction: () => {
        console.log("3 View");
        setActiveTool?.("MPR_THREE_VIEW");
        onMPRViewChange?.("THREE_VIEW");
      },
    },
  ],
});
